import { Observable } from 'rxjs';
import { GlobalPermissionsModel } from '@nimbus-global/features/permissions/models/global-permissions.model';
import { PermissionsModel } from '@nimbus-global/features/permissions/models/permissions.model';
import { NimbusPermission } from '@nimbus-global/features/permissions/models/enums/nimbus-permission.enum';
import { PermissionsSource } from '@nimbus-global/features/permissions/models/enums/permissions-source.enum';

export abstract class IPermissionManagerService {
  public abstract initialize(): void;

  public abstract reloadGlobalPermissionsModel(): Observable<GlobalPermissionsModel>;

  public abstract reloadPermissionsModel(permissionsSource?: PermissionsSource): Observable<PermissionsModel>;

  public abstract getGlobalPermissionsModel$(): Observable<GlobalPermissionsModel>;

  public abstract getGlobalPermissionsModel(): GlobalPermissionsModel;

  public abstract getPermissionsModel$(): Observable<PermissionsModel>;

  public abstract getPermissionsModel(): PermissionsModel;

  public abstract getTenantIds(): string[];

  public abstract getTeamIds$(nimbusPermission: NimbusPermission): Observable<string[]>;

  public abstract getTeamIds(nimbusPermission: NimbusPermission): string[];

  public abstract getBelongedTeamIds$(): Observable<string[]>;

  public abstract getBelongedTeamIds(): string[];

  public abstract getOwnedTeamIds$(): Observable<string[]>;

  public abstract getOwnedTeamIds(): string[];

  public abstract getSkillBasedTeamIds$(): Observable<string[]>;

  public abstract getSkillBasedTeamIds(): string[];
}
